import { TimeZone, getDefaultTimeZone } from "./timeZone";

export interface Branch {
  addressLine1: string;
  addressLine2: string;
  branchBlackoutEmail?: string;
  branchSharedCalendarEmail?: string;
  city: string;
  distance?: google.maps.Distance;
  id: number;
  latitude: number;
  longitude: number;
  name: string;
  phone: string;
  reasons: BranchReason[];
  stateCode: string;
  zip: string;
  region: string;
  timeZone: TimeZone;
  isVirtual: boolean;
  sameDayEnabled: boolean;
}

export class Branch implements Branch {}

export class BranchReason {
  appointmentsEnabled: boolean = false;
  branchId: number = -1;
  reasonId: number = -1;
}

export interface BranchHours {
  branchId: number;
  closeTimeUtc: string;
  id: number;
  openTimeUtc: string;
  weekDayCode: string;
  weekDayName: string;
}

export const getDefaultBranch = (branchId?: number): Branch => {
  return {
    id: branchId ? branchId : 0,
    name: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    stateCode: "",
    zip: "",
    latitude: 0.0,
    longitude: 0.0,
    phone: "",
    reasons: [],
    region: "",
    timeZone: getDefaultTimeZone(),
    isVirtual: false,
    sameDayEnabled: true
  };
};
